import { useT } from "@/context/LanguageContext";
import { translations } from "@/data/translations";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

export default function FAQ() {
  const t = useT(translations.faq);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-20 md:py-32"
    >
      <div className="absolute inset-0 bg-[#1a1f26]" />

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-3xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm font-medium tracking-[0.3em] uppercase text-[#b87b56]">
            {t.caption}
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold tracking-tight uppercase text-white mt-3"
            style={{ fontFamily: "Oswald, sans-serif" }}
          >
            {t.title}
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {t.items.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="border-b border-white/10"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left text-white hover:text-[#b87b56] hover:no-underline py-5 text-base font-medium">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-sm leading-relaxed pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
